/** Reviews carousel — exact mockup behavior. */
(function () {
  document.querySelectorAll('[data-zm-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-zm-carousel-track]');
    const prevBtn = carousel.parentElement.querySelector('[data-zm-carousel-prev]');
    const nextBtn = carousel.parentElement.querySelector('[data-zm-carousel-next]');
    if (!track || !track.children.length) return;

    const cards = track.children.length;
    let perView = window.innerWidth <= 640 ? 1 : window.innerWidth <= 1080 ? 2 : 3;
    let index = 0;

    function updateCarousel() {
      perView = window.innerWidth <= 640 ? 1 : window.innerWidth <= 1080 ? 2 : 3;
      const maxIndex = Math.max(0, cards - perView);
      index = Math.min(index, maxIndex);
      const cardWidth = track.children[0].getBoundingClientRect().width;
      const gap = 20;
      track.style.transform = `translateX(-${index * (cardWidth + gap)}px)`;
    }

    nextBtn?.addEventListener('click', () => {
      const maxIndex = Math.max(0, cards - perView);
      index = Math.min(index + 1, maxIndex);
      updateCarousel();
    });

    prevBtn?.addEventListener('click', () => {
      index = Math.max(index - 1, 0);
      updateCarousel();
    });

    window.addEventListener('resize', updateCarousel);
    window.addEventListener('load', updateCarousel);
    updateCarousel();
  });
})();
